//@flow

class Menu {

    items: any;
    comment: string;
    time: string;
    water: number;
    closed: boolean;
    caloriesLimit: number;
    proteinLimit: number;
    fatLimit: number;
    carbohydrateLimit: number;
    caloriesCurrent: number;
    proteinCurrent: number;
    fatCurrent: number;
    carbohydrateCurrent: number;

    constructor(
        items: *,
        comment: string,
        time: string,
        water: number,
        closed: boolean = false,
        caloriesLimit: number,
        proteinLimit: number,
        fatLimit: number,
        carbohydrateLimit: number,
        caloriesCurrent: number,
        proteinCurrent: number,
        fatCurrent: number,
        carbohydrateCurrent: number
    ) {
        this.items = items;
        this.comment = comment;
        this.time = time;
        this.water = water;
        this.closed = closed;
        this.caloriesLimit = caloriesLimit;
        this.proteinLimit = proteinLimit;
        this.fatLimit = fatLimit;
        this.carbohydrateLimit = carbohydrateLimit;
        this.caloriesCurrent = caloriesCurrent;
        this.proteinCurrent = proteinCurrent;
        this.fatCurrent = fatCurrent;
        this.carbohydrateCurrent = carbohydrateCurrent;
    }
}

export default Menu;